<template>
  <div>
    <!-- modal of all decks -->
    <div class="modal no-select" style="z-index: 600" @click="close()">
      <div class="modal-content" @click.stop=";">
        <div class="modal-header">
          <div class="modal-title-table">
            <div class="tr">
              <div class="td">
                <div class="flashcard-list-title has-text-left">Flashcard Decks</div>
              </div>
              <div @click="$emit('showFlashcardDeckEditorDefault', true)" class="icon-td">
                <div class="no-select">
                  <i class="fal fa-plus"></i>
                  <span class="small-text">Create Deck</span>
                </div>
              </div>
              <div @click="flashcardDeckHelp()" class="icon-td">
                <div class="no-select">
                  <i class="fal fa-question-circle"></i>
                  <span class="small-text">Help</span>
                </div>
              </div>
            </div>
          </div>
          <div class="deck-list-search">
            <Search @searcher="onSearch" :placeholder="'Search for a deck'" />
          </div>
        </div>
        <div class="deck-lists">
          <FlashcardDeckListItems
            :isPrivate="true"
            v-bind="{book, bookMetadata, search, flashcardDecks, flashcardDeckAttachmentsByResourceId, onCurrentPageChanged}"
          />
          <FlashcardDeckListItems
            :isPrivate="false"
            v-bind="{book, bookMetadata, search, flashcardDecks, flashcardDeckAttachmentsByResourceId, onCurrentPageChanged}"
          />
        </div>
        <div class="modal-footer">
          <button v-on:click.stop="close()" class="close-button button is-pulled-right">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import utils from "@/utils/utils.js";
import serverUtils from "@/utils/serverUtils.js";
import storeHelpers from "@/utils/storeHelpers.js";
import Popover from "@/components/widgets/popover";
import Search from "@/components/widgets/Search";
import FlashcardDeckListItems from "@/components/flashcards/FlashcardDeckListItems";

export default {
  name: "FlashcardDeckList",
  components: {
    Search,
    Popover,
    FlashcardDeckListItems
  },
  props: {
    showFlashcardDeckList: {
      type: Boolean,
      required: true
    },
    currentPage: {
      type: Object,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    },
    book: {
      type: Object,
      required: true
    },
    bookMetadata: {
      type: Object
    },
    flashcardDeckAttachmentsByResourceId: {
      type: Object,
      required: true
    },
    flashcardDecks: {
      type: Array,
      required: true
    },
    onCurrentPageChanged: {
      type: Function
    }
  },
  data: function() {
    var t = this;
    return {
      utils: utils,
      currentFlashcard: 1,
      totalPrivate: 0,
      search: ""
    };
  },
  mounted() {
    storeHelpers.checkActive(this);
    var t = this;
    document.addEventListener("keydown", function(e) {
      if (e.keyCode === 27) {
        t.close();
      }
    });
  },
  methods: {
    close: function() {
      this.$emit("closeFlashcardDeckList");
    },
    onSearch: function(val) {
      this.search = val;
    },
    flashcardDeckHelp: function() {
      window.open(
        this.$config.get("dns") +
          "/alchemy/help/Flashcards/Flashcards%20miEbooks%20students.mp4",
        "_blank"
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.modal {
  overflow-y: hidden;
  z-index: 600 !important;
  .modal-content {
    width: 450px;
    height: 70vh;
    margin: 120px auto;
    position: relative;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    .modal-header {
      position: -webkit-sticky;
      position: -moz-sticky;
      position: -ms-sticky;
      position: -o-sticky;
      position: sticky;
      top: 0;
      background: white;
      padding-top: -20px;
      z-index: 200;
      .deck-list-search {
        padding-bottom: 6px;
      }
      .modal-title-table {
        width: 100%;
        padding-top: 20px;
        display: table;
        .tr {
          display: table-row;
          .td {
            display: table-cell;
            vertical-align: middle;
            .flashcard-list-title {
              font-size: 1.5em;
              font-weight: bold;
            }
          }
          .icon-td {
            display: table-cell;
            width: 80px;
            vertical-align: middle;
            font-size: 25px;
            margin-left: 0px;
            padding: 5px 0 10px 0;
            .small-text {
              display: block;
              font-size: 12px;
            }
          }
          .icon-td:hover {
            background: $background-color-darker1;
            cursor: pointer;
          }
          .icon-td:active {
            background: $background-color-darker2;
          }
        }
      }
    }
    .modal-footer {
      position: -webkit-sticky;
      position: -moz-sticky;
      position: -ms-sticky;
      position: -o-sticky;
      position: sticky;
      bottom: 0px;
      background: white;
      height: 65px;
      .close-button {
        // margin-top: 20px;
        position: relative;
        margin-top: 15px;
      }
    }
  }
}
</style>
